// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"style_buttonsWrapper__LLtam","contentWrapper":"style_contentWrapper__fBkGz","identityImage":"style_identityImage__q28Up"};